import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_TIMESHEET } from '../../data.const';
import {
  setCurrentTimesheetAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveTimesheetEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_TIMESHEET),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_TIMESHEET}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ timesheetLoader: true })),
        defer(() =>
          from(
            request({ path: `timesheet/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_TIMESHEET}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentTimesheetAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_TIMESHEET}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ timesheetLoader: false }))
      );
    })
  );

export default retrieveTimesheetEpic;
